import axios from "axios";
import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import Swal from "sweetalert2";
import Footer from "../../Shared/Footer/Footer";
import NavBar2 from "../../Shared/NavBar2/NavBar2";
import Shop from './../Shop/Shop';
const Shops = () => {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    fetch("https://carame-cake-server-site.vercel.app/products1")
      .then((res) => res.json())
      .then((data) => setProducts(data));
  }, []);
  // handle delete btn
  const handleDeletBtn = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`https://carame-cake-server-site.vercel.app/products1/${id}`)
          .then((res) => {
            const remaining = products.filter((order) => order._id !== id);
            setProducts(remaining);
          });
        Swal.fire("Deleted!", "Your file has been deleted.", "success");
      }
    });
  };
  return (
    <div >
        <NavBar2/>
      <div className="container mt-5">
        <Row lg={3} sm={1}>
          {products.map((product) => (
            <Shop
              uid={product.uid}
              key={product._id}
              product={product}
              handleDeletBtn={handleDeletBtn}
            ></Shop>
          ))}
        </Row>
      </div>
      <Footer/>
    </div>
  );
};

export default Shops;
